<h1 mat-dialog-title>
  <ng-container>
    <span>Create New FSPS Invoice</span>
  </ng-container>
</h1>

<div mat-dialog-content #modalContainer scrollInsetShadow>

  <form name="invoice-create-form" #invoiceCreateForm="ngForm">
    <mat-button-toggle-group name="createCriteria" [(value)]="CreateCriteria" style="margin-bottom: 5px;" class="button-toggle-color-accent">
      <mat-button-toggle value="PO">PO</mat-button-toggle>
      <mat-button-toggle value="NOPO">NO PO</mat-button-toggle>
    </mat-button-toggle-group>
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>Trial/Non-Trial Year</mat-label>
      <mat-select panelClass="invoice-modal-select-panel" required [(ngModel)]="Year" #year="ngModel" name="year" (selectionChange)="OnYearChange()">
        @for (year of Dropdowns.Years; track year) {
          <mat-option [value]="year">{{year}}</mat-option>
        }
      </mat-select>
      @if (year.errors?.required) {
        <mat-error>
          Year is required
        </mat-error>
      }
    </mat-form-field>
    @if (CreateCriteria == 'PO') {
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Purchase Order Number</mat-label>
        <mat-select panelClass="invoice-modal-select-panel" required [(ngModel)]="PurchaseOrderNumber" #poNumber="ngModel" name="poNumber">
          @for (po of Dropdowns.PoNumbers; track po) {
            <mat-option [value]="po">{{po}}</mat-option>
          }
        </mat-select>
        @if (poNumber.errors?.required) {
          <mat-error>
            Purchase Order Number is required
          </mat-error>
        }
      </mat-form-field>
    }
    @if (CreateCriteria == 'NOPO') {
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Purchase Requisition Number</mat-label>
        <mat-select panelClass="invoice-modal-select-panel" required [(ngModel)]="PurchaseRequisitionNumber" #prNumber="ngModel" name="prNumber">
          @for (pr of Dropdowns.PrNumbers; track pr) {
            <mat-option [value]="pr">{{pr}}</mat-option>
          }
        </mat-select>
        @if (prNumber.errors?.required) {
          <mat-error>
            Purchase Requisition Number is required
          </mat-error>
        }
      </mat-form-field>
    }
  </form>
</div>
<div mat-dialog-actions style="display: flex">
  <span style="flex: 1 1 auto;"></span>
  <button mat-raised-button color="accent" (click)="CancelModal()">Cancel</button>
  <button mat-raised-button color="primary" (click)="SaveInvoice(invoiceCreateForm)">Create</button>
</div>
